var checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');

export const isMongoId = (str: string) => typeof str === 'string' && checkForHexRegExp.test(str);
